import * as SecureStore from "expo-secure-store";
import { Platform } from "react-native";
import { isWEB } from "./helpers/getPlatformType";

export const STORAGE = {
    set: async (key, value) => {
        if (isWEB()) {
            const { default: AsyncStorage } = await import("@react-native-async-storage/async-storage");
            await AsyncStorage.setItem(key, value);
            return;
        }

        await SecureStore.setItemAsync(key, value);
    },
    get: async (key) => {
        if (isWEB()) {
            const { default: AsyncStorage } = await import("@react-native-async-storage/async-storage");
            return await AsyncStorage.getItem(key);
        }

        return await SecureStore.getItemAsync(key);
    },
    delete: async (key) => {
        if (isWEB()) {
            const { default: AsyncStorage } = await import("@react-native-async-storage/async-storage");
            await AsyncStorage.removeItem(key);
            return;
        }

        await SecureStore.deleteItemAsync(key);
    }
};